import { createClient } from '@supabase/supabase-js';
import type { CompatibilitySession, CompatibilityAnswer } from '../types/compatible';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration');
}

const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function createCompatibilitySession(partnerAAnswers: CompatibilityAnswer[]): Promise<string> {
  const { data, error } = await supabase
    .from('compatibility_sessions')
    .insert([{
      partner_a_answers: partnerAAnswers,
      created_at: new Date().toISOString()
    }])
    .select('session_id')
    .single();

  if (error) throw error;
  return data.session_id;
}

export async function submitPartnerBAnswers(
  sessionId: string, 
  answers: CompatibilityAnswer[]
): Promise<CompatibilitySession> {
  const { data, error } = await supabase
    .from('compatibility_sessions')
    .update({
      partner_b_answers: answers,
      completed_at: new Date().toISOString(),
      score: calculateCompatibilityScore(answers) // Implement this function
    })
    .eq('session_id', sessionId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getCompatibilitySession(sessionId: string): Promise<CompatibilitySession> {
  const { data, error } = await supabase
    .from('compatibility_sessions')
    .select('*')
    .eq('session_id', sessionId)
    .single();

  if (error) throw error;
  return data;
}

function calculateCompatibilityScore(answers: CompatibilityAnswer[]): number {
  // Implement scoring logic
  return Math.floor(Math.random() * 100); // Placeholder
}